var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20711 10.2929C7.81658 9.90237 7.18342 9.90237 6.79289 10.2929C6.40237 10.6834 6.40237 11.3166 6.79289 11.7071L9.79289 14.7071C10.1834 15.0976 10.8166 15.0976 11.2071 14.7071L14.2071 11.7071C14.5976 11.3166 14.5976 10.6834 14.2071 10.2929C13.8166 9.90237 13.1834 9.90237 12.7929 10.2929L11.5 11.5858L11.5 6H16.5C17.6046 6 18.5 6.89543 18.5 8V15C18.5 16.1046 17.6046 17 16.5 17H4.5C3.39543 17 2.5 16.1046 2.5 15V8C2.5 6.89543 3.39543 6 4.5 6H9.5L9.5 11.5858L8.20711 10.2929Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C9.5 3.44772 9.94772 3 10.5 3C11.0523 3 11.5 3.44772 11.5 4L11.5 6H9.5L9.5 4Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.54e1578dcc637dec8790431e5e889a28.svg";
export { ForwardRef as ReactComponent };